import Loading from '../components/Loading';
import useHoneyBalance from '../hooks/useHoneyBalance';
import useOldHoneyBalance from '../hooks/useOldHoneyBalance';
import { FunctionComponent, useMemo } from 'react';
import { useAccount, useBalance } from 'wagmi';
import WalletAssetsContext, {
  WalletAssetsContextValue,
} from '../contexts/WalletAssetsContext';

type WalletAssetsProviderProps = {
  children: JSX.Element;
};

const WalletAssetsProvider: FunctionComponent<WalletAssetsProviderProps> = ({
  children,
}) => {
  const { address } = useAccount();

  const { data: balance, refetch: readBalance } = useBalance({
    addressOrName: address,
  });

  const [honeyBalance, readHoneyBalance] = useHoneyBalance(address);
  const [oldHoneyBalance, readOldHoneyBalance] = useOldHoneyBalance(address);

  const isLoading =
    honeyBalance === undefined ||
    oldHoneyBalance === undefined ||
    balance === undefined;

  const contextValue = useMemo<WalletAssetsContextValue>(
    () => ({
      balance: balance?.value,
      readBalance,
      honeyBalance,
      readHoneyBalance,
      oldHoneyBalance,
      readOldHoneyBalance,
    }),
    [
      balance,
      readBalance,
      honeyBalance,
      readHoneyBalance,
      oldHoneyBalance,
      readOldHoneyBalance,
    ]
  );

  return (
    <WalletAssetsContext.Provider value={contextValue}>
      {isLoading ? <Loading /> : children}
    </WalletAssetsContext.Provider>
  );
};

export default WalletAssetsProvider;
